import store from '@/store'
import commonUtils from '@/utils/commonUtils.js'
const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: () => import('@/views/homePage/HomePage.vue'),
    meta: {
      title: '主页',
      rule: 'HomePage',
      control: false
    },

    children: [
      {
        path: 'custHome',
        name: 'CustHome',
        component: () => import('@/views/custHome/CustHome.vue'),
        meta: {
          title: '主页',
          rule: 'CustHome',
          control: true
        }
      },
      {
        path: 'offSiteQuotes',
        name: 'OffSiteQuotes',
        component: () => import('@/views/offSiteQuotes/OffSiteQuotes.vue'),
        meta: {
          title: '衍生品交易参考报价',
          rule: 'OffSiteQuotes',
          control: false
        }
      },
      {
        path: 'historicalContract',
        name: 'HistoricalContract',
        component: () =>
          import('@/views/historicalContract/HistoricalContract.vue'),
        meta: {
          title: '了结交易信息',
          rule: 'HistoricalContract',
          control: false
        }
      },
      {
        path: 'bailRecovery',
        name: 'BailRecovery',
        component: () => import('@/views/bailRecovery/BailRecovery.vue'),
        meta: {
          title: '保证金追缴',
          rule: 'BailRecovery',
          control: false
        }
      },
      // {
      //   path: 'breakdownFunds',
      //   name: 'BreakdownFunds',
      //   component: () => import('@/views/breakdownFunds/BreakdownFunds.vue'),
      //   meta: { title: '资金明细', rule:"BreakdownFunds",control:false}
      // },
      {
        path: 'durationContract',
        name: 'DurationContract',
        component: () =>
          import('@/views/durationContract/DurationContract.vue'),
        meta: {
          title: '存续交易信息',
          rule: 'DurationContract',
          control: false
        }
      },
      {
        path: 'valuationReport',
        name: 'ValuationReport',
        component: () => import('@/views/valuationReport/ValuationReport.vue'),
        meta: {
          title: '估值报告',
          rule: 'ValuationReport',
          control: false
        }
      },
      {
        path: 'commodityAutoOrder',
        redirect: 'commodityAutoOrder/input',
        name: 'CommodityAutoOrder',
        component: () => import('@/views/commodityAutoOrder/CommodityAutoOrder.vue'),
        meta: {
          title: '商品询价报单',
          rule: 'CommodityAutoOrder',
          control: false
        },

        children: [
          {
            path: 'commodityAutoOrderInput',
            alias: 'input',
            name: 'CommodityAutoOrderInput',
            component: () =>
              import(
                '@/views/commodityAutoOrder/CommodityAutoOrderInput.vue'
              ),
            meta: {
              title: '商品询价报单',
              rule: 'CommodityAutoOrderInput',
              control: false
            }
          },
          {
            path: 'commodityAutoOrderSubmit',
            alias: 'submit',
            name: 'CommodityAutoOrderSubmit',
            component: () =>
              import(
                '@/views/commodityAutoOrder/CommodityAutoOrderSubmit.vue'
              ),
            meta: {
              title: '商品询价报单',
              rule: 'CommodityAutoOrderSubmit',
              control: false
            }
          }
        ]
      },
      {
        path: 'stockAutomaticOrder',
        name: 'stockAutomaticOrder',
        component: () =>
          import('@/views/stockAutomaticOrder/StockAutomaticOrder.vue'),
        meta: {
          title: '个股询价报单',
          rule: 'stockAutomaticOrder',
          control: false
        }
      },
      {
        path: 'subAccount',
        name: 'subAccount',
        component: () => import('@/views/subAccount/subAccount.vue'),
        meta: {
          title: '子账户管理',
          rule: 'subAccount',
          control: false
        }
      },
      {
        path: 'changePassword',
        name: 'ChangePassword',
        component: () => import('@/views/changePwd/ChangePwd.vue'),
        meta: {
          title: '修改密码',
          rule: 'ChangePassword',
          control: false
        }
      }
    ]
  }
]

//返还可用路由
function vailableRoutes () {
  let newRoutes = commonUtils.deepCopy(routes)
  buildRoutes(newRoutes)
  return newRoutes
}
//构建可用路由
function buildRoutes (newRoutes) {
  let length = newRoutes.length
  for (let i = 0; i < length; i) {
    if (newRoutes[i].meta.control) {
      // 如果进行控制则判断是否有权限
      if (store.getters.ruleList.indexOf(newRoutes[i].meta.rule) == -1) {
        // 失败删除此元素跳入下一循环
        newRoutes.splice(i, 1)
        length--
        continue
      }
    }
    if (newRoutes[i].children != null && newRoutes[i].children.length > 0) {
      // 递归
      buildRoutes(newRoutes[i].children)
    }
    i++
  }
}

export default vailableRoutes()
